import * as React from 'react';
import b_ from 'b_';

import './index.scss';

const b = b_.with('field-group');

export const FieldSet: React.FC = ({ children }) => <fieldset className={b()}>{children}</fieldset>;
